import { AaasSubscription } from '@va/aaas/shared/types';
import { apiGateway } from '@va/api-client';
import { VisaApiResponse } from '@visitor-analytics/3as-sdk';
import { AxiosRequestConfig } from 'axios';

export type ClientWebsitesListItem = {
  id: string;
  externalId: string;
  domain: string;
  createdAt: string;
  updatedAt?: string | null;
  subscription?: AaasSubscription | null;
};

export type FetchClientWebsitesListResponse = VisaApiResponse<ClientWebsitesListItem[]>;

export type FetchClientWebsitesListParams = {
  page: number;
  pageSize: number;
  domain?: string;
  withSubscription?: boolean; // If the response should include subscription data or not. Default to false
};

export const fetchClientWebsitesList = async (params: FetchClientWebsitesListParams, config?: AxiosRequestConfig) => {
  const queryParams = new URLSearchParams();
  queryParams.set('page', String(params.page));
  queryParams.set('pageSize', String(params.pageSize));
  if (params.withSubscription !== undefined) {
    queryParams.set('withSubscription', String(params.withSubscription));
  }
  if (params.domain !== undefined) {
    queryParams.set('domain', String(params.domain));
  }
  const query = queryParams.toString();

  const res = await apiGateway.get<FetchClientWebsitesListResponse>(
    `/v2/3as/internal/client/active-websites?${query}`,
    config,
  );

  return res;
};
